/* GENERATED by scripts/showroom/build-labels.mjs from snippets/showroom-filter-bar.liquid — do not edit by hand.
   The shop's own words for every filter value. Edit the filter bar, then re-run the script. */
window.SR_LABELS = {
  "q": {
    "stomach": "My stomach's off",
    "sleep": "I can't sleep",
    "calm": "I can't calm down",
    "focus": "I can't focus",
    "mood": "I'm feeling off",
    "run-down": "I feel run down",
    "stuffed-up": "I'm stuffed up",
    "allergies": "My allergies are acting up",
    "achy": "I'm achy / inflamed",
    "refresh": "I need to refresh",
    "stay-well": "I want to keep well",
    "not-myself": "I'm just not myself",
    "long-term": "Long-term support"
  },
  "v": {
    "newhere_section:getting-started": "Tea Types",
    "newhere_section:shopkeepers": "The Shopkeepers",
    "newhere_section:policies": "Policies",
    "ingredient_type:root": "Roots",
    "ingredient_type:herb": "Herbs & Leaves",
    "ingredient_type:flower": "Flowers",
    "ingredient_type:seed": "Seeds",
    "ingredient_type:berry": "Berries",
    "ingredient_type:bark": "Bark",
    "ingredient_type:spice": "Spices",
    "ingredient_type:leaf": "Leaves",
    "ingredient_type:peel": "Peels",
    "ingredient_type:bud": "Buds",
    "ingredient_type:resin": "Resins",
    "ingredient_benefit:sleep": "Sleep & Calm",
    "ingredient_benefit:digestive": "Digestive",
    "ingredient_benefit:immune": "Immune",
    "ingredient_benefit:anti-inflammatory": "Anti-Inflammatory",
    "ingredient_benefit:respiratory": "Respiratory",
    "ingredient_benefit:energy": "Energy",
    "ingredient_benefit:skin": "Skin",
    "ingredient_benefit:heart": "Heart",
    "ingredient_benefit:detox": "Detox",
    "ingredient_benefit:calm": "Calm",
    "ingredient_benefit:women": "Women's Health",
    "ingredient_benefit:cognitive": "Cognitive",
    "ingredient_benefit:adaptogen": "Adaptogen",
    "ingredient_benefit:mood": "Mood",
    "ingredient_benefit:pain": "Pain & Recovery",
    "ingredient_benefit:metabolism": "Metabolism",
    "ingredient_benefit:antioxidant": "Antioxidant",
    "ingredient_benefit:nutritive": "Nutritive",
    "ingredient_origin:India": "India",
    "ingredient_origin:Egypt": "Egypt",
    "ingredient_origin:China": "China",
    "ingredient_origin:Mediterranean": "Mediterranean",
    "ingredient_origin:Europe": "Europe",
    "ingredient_origin:South America": "South America",
    "ingredient_origin:Southeast Asia": "Southeast Asia",
    "ingredient_origin:Africa": "Africa",
    "ingredient_origin:North America": "North America",
    "tea_type:black": "Black",
    "tea_type:green": "Green",
    "tea_type:chai": "Chai",
    "tea_type:oolong": "Oolong",
    "tea_type:white": "White",
    "tea_type:matcha": "Matcha",
    "tea_type:pu-erh": "Pu-erh",
    "tea_type:rooibos": "Rooibos",
    "tea_type:estate": "Estate",
    "tea_type:fruit": "Fruit",
    "tea_type:christmas": "Christmas",
    "tea_energy:medium-caffeine": "Medium Caffeine",
    "tea_energy:low-caffeine": "Low Caffeine",
    "tea_energy:caffeine-free": "Caffeine-Free",
    "tea_perfect_for:latte-ready": "Latte-Ready",
    "tea_perfect_for:smoothie-upgrades": "Smoothie Upgrades",
    "tea_perfect_for:syrups": "Syrups",
    "tea_perfect_for:iced": "Iced Tea",
    "tea_perfect_for:high-tea": "High Tea",
    "tea_perfect_for:waking-up": "Waking Up",
    "tea_perfect_for:beginners": "Beginners",
    "tea_perfect_for:kids": "Kids",
    "tea_perfect_for:dessert": "Dessert",
    "tea_character:astringent": "Astringent",
    "tea_character:bold": "Bold",
    "tea_character:creamy": "Creamy",
    "tea_character:earthy": "Earthy",
    "tea_character:floral": "Floral",
    "tea_character:fruity": "Fruity",
    "tea_character:grassy": "Grassy",
    "tea_character:mild": "Mild",
    "tea_character:milky": "Milky",
    "tea_character:savory": "Savory",
    "tea_character:smoky": "Smoky",
    "tea_character:smooth": "Smooth",
    "tea_character:spiced": "Spiced",
    "tea_character:sweet": "Sweet",
    "tea_character:tart": "Tart",
    "tea_character:toasted": "Toasted",
    "tea_character:tropical": "Tropical",
    "tea_character:woody": "Woody",
    "tea_flavor:apple": "Apple",
    "tea_flavor:apricot": "Apricot",
    "tea_flavor:bergamot": "Bergamot",
    "tea_flavor:berry": "Berry",
    "tea_flavor:blueberry": "Blueberry",
    "tea_flavor:caramel": "Caramel",
    "tea_flavor:champagne": "Champagne",
    "tea_flavor:cherry": "Cherry",
    "tea_flavor:chocolate": "Chocolate",
    "tea_flavor:citrus": "Citrus",
    "tea_flavor:coconut": "Coconut",
    "tea_flavor:coffee": "Coffee",
    "tea_flavor:currant": "Currant",
    "tea_flavor:grape": "Grape",
    "tea_flavor:honey": "Honey",
    "tea_flavor:jasmine": "Jasmine",
    "tea_flavor:lavender": "Lavender",
    "tea_flavor:malty": "Malty",
    "tea_flavor:mango": "Mango",
    "tea_flavor:maple": "Maple",
    "tea_flavor:muscatel": "Muscatel",
    "tea_flavor:nutty": "Nutty",
    "tea_flavor:orange": "Orange",
    "tea_flavor:peach": "Peach",
    "tea_flavor:pineapple": "Pineapple",
    "tea_flavor:plum": "Plum",
    "tea_flavor:pumpkin": "Pumpkin",
    "tea_flavor:raspberry": "Raspberry",
    "tea_flavor:rose": "Rose",
    "tea_flavor:strawberry": "Strawberry",
    "tea_flavor:vanilla": "Vanilla",
    "benefit:stomach|burning": "Burning / Acidic",
    "benefit:stomach|bloated": "Bloated / Heavy",
    "benefit:stomach|nauseous": "Nauseous",
    "benefit:stomach|sluggish": "Sluggish / Backed Up",
    "benefit:stomach|stress-gut": "Stress stomach",
    "benefit:stomach|warming": "Warming",
    "benefit:sleep|mind-wont-stop": "Mind won't stop",
    "benefit:sleep|body-wont-relax": "Body won't relax",
    "benefit:sleep|keep-waking": "Keep waking up",
    "benefit:calm|anxious": "Anxious / Overwhelmed",
    "benefit:calm|stressed": "Stressed / Wound tight",
    "benefit:calm|decompress": "Need to decompress",
    "benefit:calm|body-tension": "Body won't unclench",
    "benefit:focus|brain-fog": "Brain fog / Fuzzy",
    "benefit:focus|deep-work": "Deep work mode",
    "benefit:focus|scattered": "Scattered / All over the place",
    "benefit:mood|low": "Low / Flat",
    "benefit:mood|anxious": "Anxious / On edge",
    "benefit:mood|swings": "Mood swings",
    "benefit:run-down|fighting": "Fighting something off",
    "benefit:run-down|recovering": "Recovering / Depleted",
    "benefit:run-down|dragging": "Just dragging",
    "benefit:run-down|crashes": "Energy crashes",
    "benefit:stuffed-up|congested": "Congested",
    "benefit:stuffed-up|sore-throat": "Sore throat",
    "benefit:stuffed-up|chest-tight": "Chest tight",
    "benefit:allergies|seasonal": "Seasonal / Hay fever",
    "benefit:allergies|sinus": "Sinus pressure",
    "benefit:achy|joint-pain": "Joint pain",
    "benefit:achy|inflammation": "General inflammation",
    "benefit:achy|headache": "Headache",
    "benefit:refresh|cleanse": "General cleanse",
    "benefit:refresh|liver": "Liver support",
    "benefit:refresh|heavy": "Feeling sluggish / heavy",
    "benefit:long-term|heart": "Heart health",
    "benefit:long-term|skin": "Skin health",
    "benefit:long-term|womens": "Women's health",
    "benefit:long-term|male": "Men's health",
    "benefit:long-term|weight": "Weight management",
    "benefit:long-term|hormonal": "Hormonal balance",
    "benefit:stay-well|daily-boost": "Daily immune boost",
    "benefit:stay-well|prevention": "Prevention",
    "benefit:stay-well|staying-strong": "Staying strong",
    "benefit:not-myself|reset": "Need a reset",
    "benefit:not-myself|spark": "Lost my spark",
    "spice_type:baking": "Baking",
    "spice_type:chiles-peppers": "Chiles",
    "spice_type:curry-blends": "Curry",
    "spice_type:dry-rubs": "Dry Rubs",
    "spice_type:garlic-onion": "Garlic/Onion",
    "spice_type:herbs": "Herbs",
    "spice_type:peppercorns": "Peppercorns",
    "spice_type:salt-finishing": "Sea Salts",
    "spice_type:specialty-blends": "Specialty Blends",
    "spice_type:single-spices": "Single Spices",
    "spice_protein:beef": "Beef",
    "spice_protein:bison": "Bison",
    "spice_protein:chicken": "Chicken",
    "spice_protein:duck-fowl": "Duck & Fowl",
    "spice_protein:eggs": "Eggs",
    "spice_protein:fish-seafood": "Fish & Seafood",
    "spice_protein:lamb": "Lamb",
    "spice_protein:pork": "Pork",
    "spice_protein:rabbit": "Rabbit",
    "spice_protein:upland-birds": "Upland Birds",
    "spice_protein:game": "Game",
    "spice_protein:vegetarian": "Vegetarian",
    "spice_protein:venison": "Venison",
    "spice_protein:wild-boar": "Wild Boar",
    "spice_dish:baked-goods-desserts": "Baked Goods & Desserts",
    "spice_dish:eggs-breakfast": "Eggs & Breakfast",
    "spice_dish:burgers-patties": "Burgers & Patties",
    "spice_dish:curry-dal": "Curry & Dal",
    "spice_dish:dips-sauces": "Dips & Sauces",
    "spice_dish:beverages-cocktails": "Drinks & Cocktails",
    "spice_dish:grills-roasts": "Grills & Roasts",
    "spice_dish:kebabs-skewers": "Kebabs & Skewers",
    "spice_dish:noodles": "Noodles",
    "spice_dish:one-pan": "One-Pan",
    "spice_dish:one-pot": "One-Pot",
    "spice_dish:pan-seared": "Pan-Seared",
    "spice_dish:pasta": "Pasta",
    "spice_dish:pies-savory": "Pies & Savory Bakes",
    "spice_dish:rice-grains": "Rice & Grains",
    "spice_dish:roasted-meats": "Roasted Meats",
    "spice_dish:roasted-vegetables": "Roasted Vegetables",
    "spice_dish:salads-dressings": "Salads & Dressings",
    "spice_dish:sandwiches-wraps": "Sandwiches & Wraps",
    "spice_dish:soups-stews": "Soups & Stews",
    "spice_dish:stir-fry": "Stir Fry",
    "spice_dish:tacos-burritos": "Tacos & Burritos",
    "spice_dish:pickling-preserving": "Pickling & Preserving",
    "spice_dish:marinades-rubs": "Marinades & Rubs",
    "spice_dish:pizza": "Pizza",
    "spice_cuisine:african": "African",
    "spice_cuisine:american-canadian": "American & Canadian",
    "spice_cuisine:cajun-creole": "Cajun & Creole",
    "spice_cuisine:caribbean": "Caribbean",
    "spice_cuisine:chinese-east-asian": "Chinese/East Asian",
    "spice_cuisine:french-european": "French & European",
    "spice_cuisine:indian-south-asian": "Indian/South Asian",
    "spice_cuisine:japanese": "Japanese",
    "spice_cuisine:mediterranean": "Mediterranean",
    "spice_cuisine:mexican-latin": "Mexican/Latin",
    "spice_cuisine:middle-eastern": "Middle Eastern",
    "spice_cuisine:thai-southeast-asian": "Thai/Southeast Asian"
  }
};
